import type { ExpertLevel } from "@shopexperts/legacy-api";

export interface DeleteLevelCopy {
  title: string;
  text: string;
  primaryActionLabel: string;
  secondaryActionLabel: string;
  isRisky: boolean;
}

/**
 * Builds the dialog copy used when an admin asks to delete an expert level.
 * Active levels get a softer warning that deactivation may be safer than
 * deletion, since deletion drops historical assignment context.
 */
export function buildDeleteLevelCopy(
  level: Pick<ExpertLevel, "public_title" | "is_active"> | null | undefined,
): DeleteLevelCopy {
  const title = level?.public_title?.trim() || "this level";

  if (level?.is_active) {
    return {
      title: `Delete "${title}"?`,
      text: `"${title}" is currently active. Experts on this level will lose their assignment, and historical references may break. Deactivating it instead keeps the data intact. Continue with delete?`,
      primaryActionLabel: "Delete Level",
      secondaryActionLabel: "Cancel",
      isRisky: true,
    };
  }

  return {
    title: `Delete "${title}"?`,
    text: `Are you sure you want to delete "${title}"? This action cannot be undone.`,
    primaryActionLabel: "Delete Level",
    secondaryActionLabel: "Cancel",
    isRisky: false,
  };
}
